import Fetch from '../Fetch';

export default {
  uploadFirmware: '/api/v1/device_fw_upload', // 固件上传

  firmwareUpgrade: (params) => { // 固件升级
    return Fetch.post(`/api/v1/device_fw_update`, params, { timeout: 60000 * 10 });
  },

  queryFirmwareList: () => { // 获取升级列表
    return Fetch.get(`/api/v1/imageInfo`);
  },

  restoreConfig: '/api/v1/restore_config_upload', // Restore config 上传

  restoreUpgrade: (params) => { // Restore config 升级
    return Fetch.post(`/api/v1/restore_config`, params);
  },

  saveBackup: (params) => { // Backup 存储
    return Fetch.post(`/api/v1/device_config`, params);
  },

  downloadBackup: () => { // Backup 下载
    return Fetch.get(`/api/v1/device_config`, { responseType: 'blob' });
  },

  factory: (params) => { // factory default
    return Fetch.post(`/api/v1/device_factory_reset`, params);
  },

  saveConfiguration: (params) => { // save Configuration
    return Fetch.post(`/api/v1/switch_config`, params);
  }
};
